/**
 * Implements a panel with buttons for manipulation
 */
import ReactTooltip from 'react-tooltip';

interface props {
  id: string;
  onCancel: (id: string) => void;
}

const Actions = ({ onCancel, id }: props) => {
  return (
    <div className='actions'>
      <div
        className='action'
        onClick={() => onCancel(id)}
        data-for={`cex-open-orders-actions-tooltip-${id}`}
        data-tip='Cancel order'
      >
        <div className='action__icon icon-trash' />
      </div>
      <ReactTooltip
        id={`limit-orders-actions-tooltip-${id}`}
        place='left'
        effect='solid'
        overridePosition={({ left }) => {
          return {
            left: left,
            top: -2,
          };
        }}
        className='actions__tooltip text_tooltip'
      />
    </div>
  );
};

export default Actions;
